import { useAppSelector } from '@/store'
import { selectDineInTableName } from '@/store/ticketSlice'
import { PillRoot, PillLabel } from './TablePill.styled'

export function TablePill() {
	const dineInTableName = useAppSelector(selectDineInTableName)

	if (!dineInTableName) return null

	return (
		<PillRoot data-testid="table-pill" aria-label={`Table ${dineInTableName}`}>
			<PillLabel>{dineInTableName}</PillLabel>
		</PillRoot>
	)
}
